<div id="title--container">
  <h4>Approvals</h4>
  <h5>{{ laboratory?.laboratoryName }}</h5>
</div>
<hr />
@if (!loading) {
  <div id="approvals--container">
    <div id="nav--container">
      <div class="button--container">
        <app-option-tab-toggle
          id="toggle--container"
          radioGroup="navigationToggle"
          [selectOptions]="navOptions"
          type="round"
        >
        </app-option-tab-toggle>
        <app-mat-fab-button
          id="refresh-btn"
          buttonStyle="success"
          iconName="refresh"
          (buttonClicked)="getUserRequests(true)"
          ariaLabel="Refresh"
          [animateSpinner]="reloadButtonProcessing"
        ></app-mat-fab-button>
      </div>
      <div class="button--container">
        <app-search-field
          [field]="searchField"
          [parentForm]="tableControls"
          (buttonClicked)="handleSearch($event)"
        >
        </app-search-field>
        <app-icon-button
          label="filters"
          buttonStyle="secondary"
          buttonId="filter-btn"
          iconName="filter_list"
          buttonShape="square"
          (buttonClicked)="openModal('filter')"
          title="Filters"
        ></app-icon-button>
      </div>
    </div>
    @if (userChangeRequests?.length > 0) {
      <div id="inner-page--container">
        <p id="table-description" style="display: none">
          User change requests table
        </p>
        <div id="table--container">
          <table aria-describedby="table-description">
            <thead>
              <tr>
                <th
                  id="request-type"
                  scope="col"
                  (click)="onSort('RequestType')"
                  [class.active]="currentSort.sortBy === 'RequestType'"
                >
                  <div id="table-header">
                    <span>Action</span>
                    <mat-icon
                      aria-label="sort direction"
                      matTooltip="Sort direction"
                      >swap_vert</mat-icon
                    >
                  </div>
                </th>
                <th
                  id="email"
                  scope="col"
                  (click)="onSort('UserEmail')"
                  [class.active]="currentSort.sortBy === 'UserEmail'"
                >
                  <div id="table-header">
                    <span>Email</span>
                    <mat-icon
                      aria-label="sort direction"
                      matTooltip="Sort direction"
                      >swap_vert</mat-icon
                    >
                  </div>
                </th>
                <th id="organisation" scope="col">
                  <div id="table-header">
                    <span>Organisation</span>
                  </div>
                </th>
                <th
                  id="request-status"
                  scope="col"
                  (click)="onSort('RequestStatus')"
                  [class.active]="currentSort.sortBy === 'RequestStatus'"
                >
                  <div id="table-header">
                    <span>Status</span>
                    <mat-icon
                      aria-label="sort direction"
                      matTooltip="Sort direction"
                      >swap_vert</mat-icon
                    >
                  </div>
                </th>
                <th
                  id="request-created"
                  scope="col"
                  (click)="onSort('CreatedAt')"
                  [class.active]="currentSort.sortBy === 'CreatedAt'"
                >
                  <div id="table-header">
                    <span>Requested On</span>
                    <mat-icon
                      aria-label="sort direction"
                      matTooltip="Sort direction"
                      >swap_vert</mat-icon
                    >
                  </div>
                </th>
                <th
                  id="requested-by"
                  scope="col"
                  (click)="onSort('RequestedBy')"
                  [class.active]="currentSort.sortBy === 'RequestedBy'"
                >
                  <div id="table-header">
                    <span>Requested By</span>
                    <mat-icon
                      aria-label="sort direction"
                      matTooltip="Sort direction"
                      >swap_vert</mat-icon
                    >
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              @for (request of userChangeRequests; track request.id) {
                <tr class="clickable-row" (click)="viewRequestDetails(request)">
                  <td headers="request-type">{{ request.requestType }}</td>
                  <td headers="email">{{ request.userEmail }}</td>
                  <td headers="organisation">{{ request.organisationName }}</td>
                  <td headers="request-status">
                    <app-status-indicator
                      [status]="request.requestStatus"
                    ></app-status-indicator>
                  </td>
                  <td headers="request-created">
                    {{ request.createdAt | date: "dd/MM/yy, HH:mm a" }}
                  </td>
                  <td headers="requested-by">{{ request.requestedBy }}</td>
                </tr>
              }
            </tbody>
          </table>
          <div id="pagination--container">
            <div class="filter--container">
              <label for="requests-per-page">Requests per page</label>
              <app-dropdown-form-field
                id="requests-per-page"
                [field]="requestsPerPageField"
                [parentForm]="tableControls"
              >
              </app-dropdown-form-field>
            </div>
            <div id="pagination--controls">
              <app-icon-button
                iconName="chevron_left"
                buttonId="previous"
                (buttonClicked)="getPrevious()"
                [isDisabled]="!hasPrevious"
              ></app-icon-button>
              <span> {{ currentPage }} / {{ totalPages }} </span>
              <app-icon-button
                iconName="chevron_right"
                buttonId="next"
                (buttonClicked)="getNext()"
                [isDisabled]="!hasNext"
              ></app-icon-button>
            </div>
          </div>
        </div>
      </div>
    }
    @if (!userChangeRequests?.length) {
      <div id="cta--container">
        <h4>No user change requests detected</h4>
        @if (error) {
          <p class="error">Error: {{ error.message }}</p>
        }
      </div>
    }
  </div>
} @else {
  <div id="loading-spinner"><app-loading-spinner></app-loading-spinner></div>
}
<app-approvals-request-modal
  id="approvals-request"
  titleText="User Change Request"
  [request]="selectedChangeRequest"
  primaryButtonText="Approve Request"
  primaryButtonId="approve-request"
  secondaryButtonText="Reject Request"
  secondaryButtonId="reject-request"
  (approvalButtonClicked)="approveRequest($event)"
  (rejectButtonClicked)="openRejectRequestModal($event)"
  [isProcessing]="requestProcessing"
></app-approvals-request-modal>
<app-modal
  id="success"
  titleText="Request Approved"
  primaryText="The user request has been approved."
  primaryButtonText="Continue"
  primaryButtonId="close"
  modalStyle="success"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-modal
  id="rejection-success"
  titleText="Request Rejected"
  primaryText="The user request has been rejected."
  primaryButtonText="Continue"
  primaryButtonId="close-rejection-success"
  modalStyle="success"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-modal
  id="rejection-fail"
  titleText="Error"
  [primaryText]="error?.message || 'Something went wrong'"
  primaryButtonText="Continue"
  primaryButtonId="close-rejection-warning"
  modalStyle="error"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-provide-info-modal
  id="provide-info"
  [approvalRequest]="userApprovalUpdate"
  (rejectionConfirmed)="rejectRequest($event)"
></app-provide-info-modal>
<app-filter-modal
  id="filter"
  primaryButtonText="Apply Filters"
  primaryButtonId="continue-button"
  secondaryButtonText="Reset"
  secondaryButtonId="reset-button"
  [statusField]="requestStatusFilters"
  [modeField]="requestActionFilters"
  [parentForm]="tableControls"
  [hideDeletedField]="true"
  (modalButtonClicked)="filterModalButtonClicked($event)"
  [isProcessing]="loading"
></app-filter-modal>
